import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeFavouritesEventProperties, IAmplitudeFavouritesEventParams} from "./get_amplitude_favourites_event_properties";

export const trackAmplitudeAddToFavourites = (params: IAmplitudeFavouritesEventParams): void => {
    trackAmplitudeEvent("add_to_favourites", getAmplitudeFavouritesEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeFavouritesEventProperties, IAmplitudeFavouritesEventParams} from "./get_amplitude_favourites_event_properties";

export const trackAmplitudeAddToFavourites = (params: IAmplitudeFavouritesEventParams): void => {
    trackAmplitudeEvent("add_to_favourites", getAmplitudeFavouritesEventProperties(params));
};
